
import { computed, ref } from '@vue/composition-api';
import Fuse from 'fuse.js';
import { Checkbox, InputText, StatusBlock } from '05-ui-kit';
import type { FilterCheckbox } from '~/type/Filter';
const __sfc_main = {};
__sfc_main.props = {
  name: {
    key: "name",
    required: true,
    type: String
  },
  list: {
    key: "list",
    required: true,
    type: Array
  },
  value: {
    key: "value",
    required: true,
    type: Object
  }
};
__sfc_main.setup = (__props, __ctx) => {
  const props = __props;
  const emit = __ctx.emit;
  const query = ref('');
  let fuse: any;
  const innerList = computed(() => {
    if (query.value) return getFuse().search(query.value)?.map((el: any) => el.item);else return props.list;
  });
  function getFuse() {
    if (!fuse) return new Fuse(props.list, {
      includeScore: true,
      keys: ['name'],
      threshold: 0.4
    });else return fuse;
  }
  function change(data: FilterCheckbox) {
    emit('change', data);
  }
  return {
    query,
    innerList,
    change
  };
};
__sfc_main.components = Object.assign({
  InputText,
  Checkbox,
  StatusBlock
}, __sfc_main.components);
export default __sfc_main;
